import type { RelocationOrderAlreadyOpenErrorResponse } from "@/common/api/relocation-order-flow/use-relocation-order-bca-init.mutation";
import { RelocationOrderAlreadyOpenErrorCode } from "@/api-schema-enums";
import { isAxiosError } from "axios";

export function getAlreadyOpenRelocationOrder(
  error: unknown,
): { relocationOrderUuid: string; isBcaOrder: boolean } | null {
  if (!isAxiosError(error) || error.response?.status !== 409) {
    return null;
  }

  const data = error.response.data as Partial<RelocationOrderAlreadyOpenErrorResponse> | undefined;
  if (data?.errorCode !== RelocationOrderAlreadyOpenErrorCode.FitRelocationOrderAlreadyOpen) {
    return null;
  }

  if (!data.details?.relocationOrderUuid) {
    return null;
  }

  return {
    relocationOrderUuid: data.details.relocationOrderUuid,
    isBcaOrder: data.details.isBcaOrder === true,
  };
}

export function normalizeVinParameter(vin: string | null): string | null {
  return vin?.trim().toUpperCase() || null;
}
